import ComponentElement from 'components/component-element';

function Pagination($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$element = $element;
    this.options = options;

    this.pages = [...this.$element.querySelectorAll('.js-page')];
    this.pages.forEach($page => {
        $page.addEventListener('click', e => {
            e.preventDefault();

            this.emit('page', $page.dataset.page, $page.href);
        });
    });
}

Pagination.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Pagination.prototype, 'constructor', {
    value: Pagination,
    writable: true,
    enumerable: false,
});

Pagination.detectPage = function () {
    const match = window.location.search.match(/[&?]page=(\d+)/);

    if (match) {
        return Number(match[1]);
    }
};

export default Pagination;
